import { z } from "zod";
import type { DailySchedule } from "./daily-schedule";
import { dailyScheduleZodSchema } from "./daily-schedule";

type WeeklySchedule = {
    mon: DailySchedule[] | boolean;
    tue: DailySchedule[] | boolean;
    wed: DailySchedule[] | boolean;
    thu: DailySchedule[] | boolean;
    fri: DailySchedule[] | boolean;
    sat: DailySchedule[] | boolean;
    sun: DailySchedule[] | boolean;
};

const weeklyScheduleZodSchema = z.object({
    mon: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
    tue: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
    wed: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
    thu: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
    fri: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
    sat: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
    sun: z.union([z.array(dailyScheduleZodSchema), z.boolean()]),
});

export { weeklyScheduleZodSchema };
export type { WeeklySchedule };
